import styled from "styled-components";
import PabloPilascoImg from "./img/4_ELEPHANT.gif"
import AlternativeCostumesImg from "./img/roupasalternativas.png"
import { TipMouseOverEvent, TipMouseOutEvent } from "../../../../Tooltip/Tooltip";
import { ZoomInFunction } from "../../../../Functions/ZoomInFunction";
import VipIconImg from "../img/goldstar.png"

function RoupasEstilos(){
    return(
        <MasterRoupasEstilos >

            <TitleMaster>
                <ColumItemHeaderIcon iconImg={VipIconImg}/>
	            <TitleFont>Skins Alternativas 3rd</TitleFont>
            </TitleMaster>

            <Session1>
                <PabloPilasco onMouseOver={(event) => TipMouseOverEvent(event, "NPC Pablo Pilásco</b> em <b>Izlude</b> - 138 154", "rgb(17, 104, 204)")} onMouseLeave={() => TipMouseOutEvent()}/>

                <TitleContainer>
	                <Span>
                        Com o seu período VIP ativo, basta falar com o <b>NPC Pablo Pilásco</b> em <b>Izlude</b> -  138 154 e escolher o estilo de roupa e cor desejados para seu personagem, lembrando que até o último     lançamento (kRO) as opções de roupas ainda estão disponíveis somente para as 3rd's.
                    </Span>
                </TitleContainer>
            </Session1>

	        <AlternativeCostumes onMouseOver={(event) => TipMouseOverEvent(event, "Opções disponíveis para as 3rd's", "rgb(0, 0, 0)")} onMouseLeave={() => TipMouseOutEvent()}/>
	
		</MasterRoupasEstilos>
    )
}


export default RoupasEstilos;

const MasterRoupasEstilos = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    //padding: 30px 20px;
    margin-top: 0px;
    //border: solid;
    width: 100%;

    @media(max-width: 1000px) {
      width: 90vw;
    }
`

const TitleMaster = styled.div`
    display: flex;
    align-items: center;
    justify-content: start;
    width: 100%;
    border-radius: 10px;
    transition: .3s ease-in-out;
    margin: 20px 0;
    //border: solid;
    background-color: rgba(0,0,0,.7);
    color: white;
    font-size: 14pt;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

    @media(max-width: 1000px) {
      width: 90vw;
      padding: 0 0px;
    }

`

const TitleFont = styled.span`
    font-size: 24pt;
    font-weight: bold;
    margin: 25px 0;

    @media(max-width: 1000px) {
      font-size: 20pt
    }

`

const ColumItemHeaderIcon = styled.div`
    background-image: url(${props => props.iconImg});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 45px;
    height: 45px;
    margin: 0 55px;
    //border: solid;

    @media(max-width: 1000px) {
        width: 35px;
        height: 35px;
        margin: 0 20px;
    }
    
`

const PabloPilasco = styled.div`
    background-image: url(${PabloPilascoImg});
    background-repeat: no-repeat;
    background-size: cover;
    width: 130px;
    height: 115px;
    margin: 0px 0;
    z-index: 1;
    margin-right: 70px;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
        
     }

    @media(max-width: 1000px) {
      scale: .9;
      margin-right: 0px;
      align-items: center;
      //border: solid;
    }
`

const TitleContainer = styled.span`
    display: flex;
    width: 700px;
    border-radius: 5px;
    padding: 10px 0px;
    background-color: rgba(0,0,0,.7);
    color: white;
    margin: 20px 0 0px 0;

    @media(max-width: 1000px) {
        scale: 1.0;
        width: 100%;
        align-items: center;
        //border: solid;
        text-align: center;
    }
`

const Span = styled.span`
    font-size: 14pt;
    margin: 10px 40px;
`

const AlternativeCostumes = styled.div`
    background-image: url(${AlternativeCostumesImg});
    background-repeat: no-repeat;
    background-size: cover;
    width: 100%;
    height: 252px;
    z-index: 4;
    transition: .3s ease-in-out;
    margin: 30px 0;
    filter: saturate(.5);

    &:hover {
        scale: 1.1;
        filter: saturate(1.5);
    }

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
        
     }

    @media(max-width: 1000px) {
        width: 100vw;
        height: 130px;
        scale: 1;
        padding: 0px 0px;
    }
`

const Session1 = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-evenly;;
    //border: solid;
    width: 100%;
    padding: 20px 0px;
    margin-bottom: 10px;

    @media(max-width: 1000px) {
      width: 90%;
      flex-direction: column;
      padding: 0px 0px;
    }
`
